import React from 'react';
import DefaultLayout from '../layouts';
import { Blocks, default as PageBlock } from '../components/PageBlocks';
import { Link, graphql } from 'gatsby';
import Button from '../components/Button';
import { Helmet } from 'react-helmet';

export function extractID(url) {
  const regex = /https:\/\/docs.google.com\/document\/d\/(.*)\/edit/;
  const match = url.match(regex);
  if (match) {
    return match[1];
  }
  return null;
}

export function toPDF(url) {
  const id = extractID(url);
  return `https://docs.google.com/document/u/0/export?format=pdf&id=${id}&includes_info_params=true&cros_files=false`;
}

export function toPreview(url) {
  return `https://drive.google.com/file/d/${extractID(url)}/preview`;
}

export function toCopy(url) {
  const id = extractID(url);
  return `https://docs.google.com/document/d/${id}/copy`;
}

export function toThumbnail(url) {
  const id = extractID(url);
  return `https://lh3.google.com/u/0/d/${id}=k`;
}

function PapersignTemplate({ template, ...props }) {
  return (
    <DefaultLayout {...props}>
      <Helmet
        title={`${template.title} | Free PDF Templates | Papersign`}
        description={template.description}
      />
      <Blocks.ctaBanner
        containerClassName={'pt-12 xl:pt-0'}
        title={
          <>
            <span>{template.title}</span>
            <Link
              to="/pdf-templates"
              className="uppercase text-xs block mt-2 text-black hover:text-black/60 font-medium"
            >
              － Free PDF Templates{' '}
            </Link>
          </>
        }
        description={
          <>
            <p>{template.description}</p>
          </>
        }
        link={{
          link_url: 'https://paperform.co/templates',
          link_text: 'Start signing for free today with Papersign',
        }}
      />

      {
        <div className="w-[1024px] max-w-full mx-auto m-4 px-3">
          <iframe
            src={toPreview(template.doc_url)}
            width="100%"
            height="1000px"
            className="mt-4 border-2 rounded-xl"
            style={{ maxHeight: '96vh' }}
          ></iframe>
          <div className="text-center">
            <Button
              sm
              target={'_blank'}
              className="mr-3 mb-3"
              href={toCopy(template.doc_url)}
            >
              Copy to Google Docs
            </Button>
            <Button
              sm
              primary
              className="mr-1  mb-3"
              target={'_blank'}
              href={toPDF(template.doc_url)}
            >
              Download as PDF
            </Button>{' '}
            →
            <Button
              sm
              target={'_blank'}
              className="ml-2  mb-3"
              secondary
              solid
              href={'/sign/new-document'}
            >
              Sign free with Papersign
            </Button>
          </div>
        </div>
      }
      {template.content &&
        template.content.map((block, i) => {
          return <PageBlock key={i} block={block} type={block.type} />;
        })}

      <div className="bg-white ">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-center py-24 px-3">
            Want more free document templates?{' '}
            <Link href="/pdf-templates">Let's go →</Link>
          </h3>
        </div>
      </div>
      <Blocks.trust />
      <div className="max-w-[1680px] mx-auto pt-12 pb-8 px-10 text-[16px] leading-5">
        <strong class="block mb-1">Disclaimer:</strong>
        <p>
          *Paperform (“<strong>Paperform</strong>” or “<strong>we</strong>”)
          provides the information, data, links and other materials on this page
          (collectively, “<strong>Information</strong>”) for informational and
          educational purposes only. We do not warrant or represent the
          accuracy, completeness, currency, or suitability of any Information
          for any use or purpose. Paperform is not a licensed legal provider nor
          is it providing any legal advice; the Information should not be so
          construed or used. Nothing contained in the Information is intended to
          create an attorney-client relationship, to replace the services of a
          licensed, trained attorney or legal professional, or to be a
          substitute for the legal advice of an attorney or trained legal
          professional licensed in your state/jurisdiction. Before taking any
          action, including using our services to execute contracts or other
          documents, You should always first consult an attorney licensed in
          your state/jurisdiction, in each instance, regarding the issues
          address by the Information. Please&nbsp;
          <strong>
            NEVER DISREGARD PROFESSIONAL LEGAL ADVICE OR DELAY IN SEEKING IT
            BECAUSE OF SOMETHING YOU HAVE READ IN THE INFORMATION.
          </strong>
          *
        </p>
      </div>
    </DefaultLayout>
  );
}

export default function (props) {
  const { data } = props;
  const template = data.allPaperformHelpPapersignTemplates.edges[0];
  return <PapersignTemplate {...props} template={template.node} />;
}

export const query = graphql`
  query PapersignTemplateQuery($slug: String) {
    allPaperformHelpPapersignTemplates(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          id
          title
          description
          slug
          content {
            ...ComponentsFragment
          }
          doc_url
        }
      }
    }
  }
`;
